export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const JWT_TOKEN_STORAGE = "jwtToken";
export const USE_GRID_VIEW = "useGridView";
export const GOOGLE_CLIENT_ID =
  "323044269310-jpacaee5fqigd05rolak62uto6mfnmcb.apps.googleusercontent.com";

export const APP_BRAND_NAME = "PLANTOPTICON";
